import React from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-bootstrap';
import {setShowUpdateRecurringModal, setRecurringItem} from "../../actions/store/recurringOrderActions";
import {translate} from '../../i18n/translate.js';
import {isFetching} from "../../actions/common/fetchingActions";
import {FetchingTypes} from "../../common/constants";
import RecurringItem from "../../components/store/RecurringItem";
import {changeItemQuantity} from "../../actions/store/itemCardActions";
import {setDirty} from "../../actions/common/commonActions";
import {getUsefulDate} from "../../common/utils";
import recurringOrderItems from "../../css/store/recurringOrederItems.less";

class RecurringOrderItems extends React.Component {
    getItems = () => {
        const recurringOrderItems = this.props.recurringOrder.items || [];
        let recurringItems = {};
        let recurringKeys = [];
        recurringOrderItems.map(function (recurringItem) {
            recurringItems[recurringItem.key] = recurringItem.schedule;
        });
        const editableItems = this.props.webOrderItems.editableItems;
        const fixedItems = this.props.webOrderItems.fixedItems;
        const creditEditableItems = this.props.webOrderItems.creditEditableItems;
        const creditFixedItems = this.props.webOrderItems.creditFixedItems;
        const extraCreditKey = this.props.extraCreditKey;
        let currentRecurringItems = [].concat(editableItems).concat(creditEditableItems).filter(function (item) {return item.key !== extraCreditKey;});
        currentRecurringItems.map(function (item) {
                item.schedule = recurringItems[item.key];
                recurringKeys.push(item.key);
            });
        let fixedCurrentRecurringItems = [].concat(fixedItems).concat(creditFixedItems).filter(function (item) {return item.key !== extraCreditKey;});
        fixedCurrentRecurringItems.map(function (item) {
                item.schedule = recurringItems[item.key];
                recurringKeys.push(item.key);
            });

        let notInOrderRecurringOrders = [];
        recurringOrderItems.map(function (item) {
            if (!recurringKeys.includes(item.key) && item.schedule !== undefined) {
                notInOrderRecurringOrders.push(item);
            }
        });

        const that = this;
        return (<div>
            {fixedCurrentRecurringItems.length > 0 ?
                <div>
                    {fixedCurrentRecurringItems.map(item => {
                        return that.getItem(item, true);
                    })}
                </div> : undefined
            }
            {currentRecurringItems.length > 0 ?
                <div>
                    {currentRecurringItems.map(item => {
                        return that.getItem(item, this.props.readOnly);
                    })}
                </div> : undefined
            }
            {notInOrderRecurringOrders.length > 0 ?
                <div>
                    <div className="recurring-order-items-title not-in-order">{"Recurring items not in " +  getUsefulDate(this.props.nextDeliveryDate) + " order"}</div>
                    {notInOrderRecurringOrders.map(item => {
                        return that.getItem(item, this.props.readOnly);
                    })}
                </div>:undefined
            }
        </div>);
    };

    updateWebOrder = (item, remove) => {
        this.props.changeItemQuantity(item, remove?-1:item.quantity, remove?item.quantity:0, this.props.creditsData, true);
        this.props.setDirty(true);
    };

    getItem = (item, disabled) => {
        if(item.quantity > 0) {
            return (<RecurringItem item={item} clientViewPort={this.props.clientViewPort}
                                   key={item.key} disabled={disabled} staticData={this.props.staticData}
                                   farmSchedules={this.props.recurringOrder.farmSchedules}
                                   nextDeliveryDate={this.props.nextDeliveryDate}
                                   updateWebOrder={this.updateWebOrder}
                                   setRecurringItem={this.props.setRecurringItem}
            />);
        }
    };

    continueButtonClicked = () => {
        this.props.setShowUpdateRecurringModal(false);
    };

    render() {
        if(!(this.props.recurringOrder||{}).items) {
            return (<div>There are not any recurring items to show</div>);
        }
        return (
            <div className="recurring-items-container">
                <div className="recurring-order-items-title">Please set schedule for items you would like to receive as a recurring order</div>
                {
                    this.props.clientViewPort.isXs ?
                        <hr className="summary-item-divider"/> : undefined
                }
                {this.getItems()}
                <div className="recurring-setting-footer">
                    <Button onClick={this.continueButtonClicked}
                    type="submit"
                    className={"submit-order button recurring-continue-btn" + (this.props.showLoading ? " loading" : "")}
                    bsStyle="primary">{translate("Back to Order")}</Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const webOrderItems =  (state.orderStatus || {}).orderedItems;
    const extraCreditKey = ((state.storeCreditsData||{}).extraCreditItem||{}).key;
    return {
        recurringOrder: (state.recurringOrder || {}),
        showLoading: isFetching(state, FetchingTypes.VALIDATE_UPDATE_MEMBER),
        clientViewPort: (state.clientViewPort || {}),
        staticData: state.staticData,
        nextDeliveryDate: (state.summary||{}).nextDeliveryDate,
        creditsData: (state.storeCreditsData || {}),
        webOrderItems: webOrderItems,
        extraCreditKey: extraCreditKey

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setShowUpdateRecurringModal: isShowRecurringModal => {
            dispatch(setShowUpdateRecurringModal(isShowRecurringModal));
        },
        changeItemQuantity: (item, newQuantity, oldQuantity, creditData, updateSchedule) => {
            dispatch(changeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule));
        },
        setRecurringItem: (item, updateSchedule) => {
          dispatch(setRecurringItem(item, updateSchedule))
        },
        setDirty: isDirty => {
            dispatch(setDirty(isDirty));
        }
    }
};


export default connect(mapStateToProps, mapDispatchToProps)( RecurringOrderItems );


// WEBPACK FOOTER //
// ./src/containers/store/RecurringOrderItems.js